import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
import { client } from '../../../utils/apolloClient'
import axios from 'axios';

const initialState = {
  subscriptionConsents:[],
  issaveApiConsentSuccess: false,
  issaveApiConsentPending: false,
  issaveApiConsentFailed: false,
  disableSuccess:false,
  disablePending:false,
  disableFailed:false,
  enableSuccess:false,
  enablePending:false,
  enableFailed:false
};


export const bulkConnectionEnable = createAsyncThunk(
    'bulkConnectionEnable',
    async ({payload, token}) => {
      let response = await client.authorizeRequest({
        method: 'POST',
        url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/bulk/enable`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        data: { ...payload }
      });
      return response;
    }
);

export const bulkConnectionDisable = createAsyncThunk(
    'bulkConnectionDisable',
    async ({payload, token}) => {
      let response = await client.authorizeRequest({
        method: 'POST',
        url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/bulk/disable`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        data: { ...payload }
      });
      return response;
    }
);

export const saveApiConsentForMultipleLocations = createAsyncThunk(
    'saveApiConsentForMultipleLocations',
    async ({solution, consent, token}) => {
        const { id: solutionId, listingVersion = '1' } = solution;
      let response = await client.authorizeRequest({
        method: 'POST',
        url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/solutions/${solutionId}/${listingVersion}/consents/multiple`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          data: {
            consent: consent
          }
      });
      return response;
    }
);

export const getUserDetailsForBulkConnection = createAsyncThunk(
  'getUserDetailsForBulkConnection',
  async ({  firstName,lastName,userEmail,token}) => {
    let response = await axios.get(
      `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/user/role?email=${userEmail}&firstName=${firstName}&lastName=${lastName}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response;
  }
);


export const manageBulkConnectionsSlice = createSlice({
  name: 'manageBulkConnectionsSlice',
  initialState,
  reducers: {
    updateConsentSuccess: (state)=>{
      state.enableSuccess = false
      state.disableSuccess = false
    },
    updateConsentfailed: (state)=>{
      state.enableFailed = false
      state.disableFailed= false
    },
    updateSaveConsentSuccess :(state)=>{
      state.issaveApiConsentSuccess = false
    },
    clearState : (state) => {
      state.disableSuccess = false
      state.enableSuccess = false
      state.enableFailed = false
      state.disableFailed = false
    },
  },
  extraReducers: {
    [saveApiConsentForMultipleLocations.fulfilled]: (state, action) => {
      state.issaveApiConsentSuccess = true;
      state.issaveApiConsentPending = false;
    },
    [saveApiConsentForMultipleLocations.pending]: (state, action) => {
      state.issaveApiConsentPending = true;
    },
    [saveApiConsentForMultipleLocations.rejected]: (state, action) => {
      state.issaveApiConsentPending = false;
      state.issaveApiConsentFailed = true;
    },
    [bulkConnectionDisable.fulfilled]: (state, action) => {
      state.disableSuccess = true;
      state.disablePending = false;
    },
    [bulkConnectionDisable.pending]: (state, action) => {
      state.disablePending = true;
    },
    [bulkConnectionDisable.rejected]: (state, action) => {
      state.disablePending = false;
      state.disableFailed = true;
    },
    [bulkConnectionEnable.fulfilled]: (state, action) => {
      state.enableSuccess = true;
      state.enablePending = false;
    },
    [bulkConnectionEnable.pending]: (state, action) => {
      state.enablePending = true;
    },
    [bulkConnectionEnable.rejected]: (state, action) => {
      state.enablePending = false;
      state.enableFailed = true;
    }
  }
});

export const { updateConsentSuccess,updateConsentfailed ,updateSaveConsentSuccess, clearState } = manageBulkConnectionsSlice.actions;
export default manageBulkConnectionsSlice.reducer;
